import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PostModalProps } from "../interfaces/post.interface";
import PostComposer from "./PostComposer";



const PostModal: React.FC<PostModalProps> = (props) => {
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
  <Dialog as="div" className="relative z-50" onClose={props.onClose}>
    {/* Overlay with blur */}
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-opacity-30 backdrop-blur-xl" />
    </Transition.Child>

    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white dark:bg-dark_grey p-6 text-left align-middle shadow-xl transition-all relative">
            
            {/* Close button */}
            <button
              type="button"
              onClick={props.onClose}
              className="absolute top-4 cursor-pointer right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>

            <Dialog.Title className="text-xl font-medium text-gray-900 dark:text-muted mb-4">
              Create Post
            </Dialog.Title>

            {/* Post composer component */}
            <PostComposer {...props} />

          </Dialog.Panel>
        </Transition.Child>
      </div>
    </div>
  </Dialog>
</Transition>


  );
};

export default PostModal;
